import { useQuery } from "@tanstack/react-query";
import { getHeyApiRequestOptions } from "apiClients/base/heyApiRequestOptions";
import type { DashboardOverviewResponse } from "../types";

async function fetchDashboardOverview(): Promise<DashboardOverviewResponse> {
  const options = getHeyApiRequestOptions();
  const auth = options.auth?.();
  const response = await fetch(`${options.baseUrl}/api/statistics/overview`, {
    headers: {
      Accept: "application/json",
      ...(auth ? { Authorization: auth } : {}),
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to load dashboard overview (${response.status})`);
  }

  return (await response.json()) as DashboardOverviewResponse;
}

export function useDashboardOverviewQuery() {
  return useQuery({
    queryKey: ["dashboard-overview"],
    queryFn: fetchDashboardOverview,
  });
}
